import R from '../../core-res/R';
export default {
    INFO: {
        containerStyle: {
            backgroundColor: R.color.uiBlueLight,
            borderColor: R.color.uiBlueSecondary,
        },
        textStyle: {
            color: R.color.uiBlueDark,
        },
    },
    POSITIVE: {
        containerStyle: {
            backgroundColor: R.color.uiGreenLight,
            borderColor: R.color.uiGreenSecondary,
        },
        textStyle: {
            color: R.color.uiGreenDark,
        },
    },
    ALERT: {
        containerStyle: {
            backgroundColor: R.color.uiRedLight,
            borderColor: R.color.uiRedSecondary,
        },
        textStyle: {
            color: R.color.uiRedDark,
        },
    },
    WARNING: {
        containerStyle: {
            backgroundColor: R.color.uiYellowLight,
            borderColor: R.color.uiYellowSecondary,
        },
        textStyle: {
            color: R.color.uiYellowDark,
        },
    },
};
